export const STORE_DATA = 'STORE_DATA';
export const STORE_UPDATE_LIKES = 'STORE_UPDATE_LIKES';
